module.exports = __webpack_public_path__ + "static/media/ag.53a60086.svg";